import {
  SIGNIN,
  AUTHENTICATED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SIGNUP,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  HIDE_AUTH_MESSAGE,
  SHOW_AUTH_MESSAGE,
  STORE_PERMISSIONS,
  GET_PERMISSIONS,
} from "../constants/Auth";

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user,
  };
};

export const getPermissionsAction = () => {
  return {
    type: GET_PERMISSIONS,
  };
};

export const storePermissionsAction = (permissions) => {
  return {
    type: STORE_PERMISSIONS,
    permissions,
  };
};

export const authenticated = (token) => {
  return {
    type: AUTHENTICATED,
    token,
  };
};

export const signOut = () => {
  return {
    type: SIGNOUT,
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  };
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user,
  };
};

export const signUpSuccess = (token) => {
  return {
    type: SIGNUP_SUCCESS,
    token,
  };
};

export const hideAuthMessage = (message) => {
  return {
    type: HIDE_AUTH_MESSAGE,
    message,
  };
};

export const showAuthMessage = (message, error) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message,
    error,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};
